<ng-container [ngSwitch]="applicationType">
  <div *ngSwitchCase="applicationTypeEnum.AWE" class="header-container">
    Søknad om tiltak uten ansvarsrett
  </div>
  <div *ngSwitchCase="applicationTypeEnum.CertificateOfCompletion" class="header-container">
    Søknad om ferdigattest
  </div>
  <div *ngSwitchCase="applicationTypeEnum.ApplicationSupplement" class="header-container">
    Supplering av søknad
  </div>
</ng-container>
